export const environment = {

    apiBaseUrl: 'https://mv-backoffice.tourismotion.com/api/v1',
    currentUser: {
        userProfiles: [{ profile: '', agency: undefined }]
    },
    
};
